export let NAVIGATION_ARROWS_BEHAVIOR = /*#__PURE__*/function (NAVIGATION_ARROWS_BEHAVIOR) {
  NAVIGATION_ARROWS_BEHAVIOR[NAVIGATION_ARROWS_BEHAVIOR["ON_HOVER"] = 0] = "ON_HOVER";
  NAVIGATION_ARROWS_BEHAVIOR[NAVIGATION_ARROWS_BEHAVIOR["ALWAYS"] = 1] = "ALWAYS";
  return NAVIGATION_ARROWS_BEHAVIOR;
}({});
//# sourceMappingURL=navigation-arrows-behavior.js.map